import {
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
  Box,
  Button,
} from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { useState } from 'react'

function OtherItemsList({ items }) {
  const [expanded, setExpanded] = useState(false)
  const displayItems = expanded ? items : items.slice(0, 3)
  
  return (
    <Box>
      <List sx={{ width: '100%' }}>
        {displayItems.map((item, index) => (
          <Box key={index}>
            <ListItem 
              sx={{ 
                py: 1,
                px: 2,
                transition: 'background-color 0.2s',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
                borderRadius: 1,
              }}
            >
              <ListItemText 
                primary={
                  <Typography variant="body2" color="text.primary">
                    {item}
                  </Typography>
                }
              />
            </ListItem>
            {index < displayItems.length - 1 && (
              <Divider component="li" sx={{ mx: 2 }} />
            )}
          </Box>
        ))}
      </List>
      
      {items.length > 3 && (
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 1 
          }}
        >
          <Button
            size="small"
            onClick={() => setExpanded(!expanded)}
            endIcon={
              <KeyboardArrowDownIcon 
                sx={{ 
                  transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s',
                }}
              />
            }
          >
            {expanded ? 'Show Less' : 'Show More'}
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default OtherItemsList
